
import { Component, Vue } from 'vue-property-decorator';

import Form4ProcessHeader from "@/components/process/Form4/components/Form4ProcessHeader.vue";
import Form4StyleOfProceeding from "@/components/process/Form4/components/Form4StyleOfProceeding.vue";
import { form4StatusInfoType } from '@/types/Information/Form4';

@Component({
    components:{
        Form4ProcessHeader,        
        Form4StyleOfProceeding
    }
})
export default class FillForm4 extends Vue {

    stepsCompleted = {} as form4StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
